import { autoUpdate, useFloating } from "@floating-ui/react";
import clsx from "clsx";
import React from "react";
import { Portal } from "../portal";

const PADDING = 0;

const defaultBoundingRect = {
	x: 0,
	y: 0,
	width: 0,
	height: 0,
};

export function DragOverIndicator() {
	/** Hooks */
	const { refs } = useFloating({
		placement: "top-start",
		whileElementsMounted: autoUpdate,
	});

	const boundingRect = refs.reference.current?.getBoundingClientRect() ?? defaultBoundingRect;

	const top = boundingRect.y - PADDING;
	const left = boundingRect.x - PADDING;
	const width = boundingRect.width + PADDING * 2;
	const height = boundingRect.height + PADDING * 2;

	/** Render */
	return (
		<React.Fragment>
			<div
				className="absolute inset-0 pointer-events-none"
				ref={refs.setReference}
			/>
			<Portal>
				<div
					ref={refs.setFloating}
					className={clsx(
						"z-509 border-[0.5px] ring-2 pointer-events-none",
						"ring-accent-500/10 border-accent-500",
						"dark:ring-accent-700/10 dark:border-accent-700",
					)}
					style={{
						borderRadius: `calc(var(--radius-base) - ${PADDING}px)`,
						position: "fixed",
						top,
						left,
						width,
						height,
					}}
				/>
			</Portal>
		</React.Fragment>
	);
}
